/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserUpdateRequestCto } from '../../models/user-update-request-cto';
import { UserUpdateResponseCto } from '../../models/user-update-response-cto';

export interface UpdateUserModuleAccess$Json$Params {
  userId: string;
      body?: UserUpdateRequestCto
}

export function updateUserModuleAccess$Json(http: HttpClient, rootUrl: string, params: UpdateUserModuleAccess$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UserUpdateResponseCto>> {
  const rb = new RequestBuilder(rootUrl, updateUserModuleAccess$Json.PATH, 'patch');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserUpdateResponseCto>;
    })
  );
}

updateUserModuleAccess$Json.PATH = '/user/{userId}/access';
